export const createAction = (type, data) => {
  return { type: type, data: data };
};
